import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Action, Note } from "./ui";

export default function PermissionsTab() {
  const [tools, setTools] = useState([]);
  const [perm, setPerm] = useState({});
  const [confirmations,setConfirmations]=useState("on");
  useEffect(() => {
    api.get("/settings").then(r=>setConfirmations(r.data?.execution?.confirmations||"on"));
    api.get("/tools").then((r) => { setTools(r.data); setPerm(Object.fromEntries(r.data.map((t) => [t.name, t.policy]))); });
  }, []);
  const save = async () => { try { await api.put("/settings", { permissions: perm,execution:{confirmations} }); toast.success("Permisos guardados"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Panel title="PERMISOS DE HERRAMIENTAS" testId="permissions-panel" right={<Action testId="permissions-save-button" onClick={save}>Guardar</Action>}>
      <Note>La IA solo propone herramientas tipadas; el ejecutor valida argumentos y aplica esta política. No existen comandos arbitrarios. Riesgo alto = confirmar por defecto.</Note>
      <label className="flex items-center gap-2 py-3"><input type="checkbox" checked={confirmations==="off"} onChange={e=>setConfirmations(e.target.checked?"off":"on")}/>Ejecución directa para acciones permitidas; las operaciones protegidas conservan su confirmación</label>
      <div className="mt-3 divide-y divide-cyan-500/10">
        {tools.map((t) => (
          <div key={t.name} className="grid grid-cols-[1fr_auto] sm:grid-cols-[220px_1fr_auto] gap-2 py-2 items-center text-xs" data-testid={`perm-row-${t.name}`}>
            <span className="text-cyan-200">{t.name} <span className={`ml-1 text-[10px] ${t.risk === "alto" ? "text-red-300" : "text-slate-500"}`}>{t.risk}</span></span>
            <span className="hidden sm:block text-slate-500">{t.description}</span>
            <select value={perm[t.name]} onChange={(e) => setPerm({ ...perm, [t.name]: e.target.value })} data-testid={`perm-select-${t.name}`}
              className="border border-cyan-500/30 bg-slate-950 px-2 py-1 text-xs">
              <option value="permitir">Permitir</option><option value="confirmar">Confirmar</option><option value="denegar">Denegar</option>
            </select>
          </div>
        ))}
      </div>
    </Panel>
  );
}
